export default __webpack_public_path__ + "9b252ac3c64df27e39dcfd7066115c87.svg";